import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "moment/locale/si";
import { fontSize } from "@mui/system";
import { useTranslation } from "react-i18next";

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '16px',
    background: '#fff',
};

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '4px',
    textAlign: 'center',
};

const tdTdStyle = {
    border: '1px solid #ccc',
    padding: '4px',
    textAlign: 'left',
    fontSize: '14px',
};

function EtashtakaTable({ erashtakaRecords }) {
    const { t } = useTranslation();
    const lang = localStorage.getItem('language') || 'si';
    moment.locale(lang); // Set the locale based on the selected language
       
    return (
        <div>
            <div style={{ textAlign: 'left', margin: '24px 0 12px 0', fontWeight: 'bold', fontSize: '0.8em' }}>
                {t("Erashtaka")}
            </div>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thTdStyle}>{t("Erashtaka")}</th>
                        <th style={thTdStyle}>{t("From")}</th>
                        <th style={thTdStyle}>{t("To")}</th>
                        <th style={thTdStyle}>{t("Duration")}</th>
                    </tr>
                </thead>
                <tbody>
                    {erashtakaRecords.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdTdStyle}>{row.name}</td>
                            <td style={tdTdStyle}>{moment(new Date(row.from)).format('YYYY - MMMM - DD')}</td>
                            <td style={tdTdStyle}>{moment(new Date(row.to)).format('YYYY - MMMM - DD')}</td>
                            <td style={tdTdStyle}>{row.duration}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
    EtashtakaTable.propTypes = {
        erashtakaRecords: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                from: PropTypes.string.isRequired,
                to: PropTypes.string.isRequired,
                duration: PropTypes.string.isRequired,
            })
        ).isRequired,
    };
}

export default EtashtakaTable;